export let saleHours = {
  //折线图
  id: 'saleHours',
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    legend: {
      data: ['销售金额', '交易单数'],
      selectedMode: 'single',//图例单选模式
      selected: {//默认不选中
        '交易单数': false,
      }
    },
    grid: {
      top: '10%',
      left: '3%',
      right: '5%',
      bottom: '2%',
      containLabel: true
    },
    color: ['#409eff', '#47c993'],
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '100%'],
      splitLine: {
        show: true,
      }
    },
    series: [
      {
        name: '销售金额',
        data: [],
        type: 'line',
        smooth: true,
        areaStyle: {}
      },
      {
        name: '交易单数',
        data: [],
        type: 'line',
        smooth: true,
        areaStyle: {}
      }
    ]
  }
}
export let leftTopPic = {
  id: "leftTopPic",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        animation: false,
        type: 'cross'
      }
    },
    legend: {
      data: ['销售金额', '交易单数'],
      icon: "roundRect ",
      left: "center",
      itemWidth: 20,
      itemHeight: 12
    },
    grid: {
      top: '9%',
      left: '3%',
      right: '5%',
      bottom: '4%',
      containLabel: true
    },
    color: ['#409eff', '#47c993'],
    xAxis: {
      type: 'category',
      splitLine: {
        show: false,
      },
      data: []
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '100%'],
      splitLine: {
        show: true,
      }

    },
    //下方滚动条
    dataZoom: [{
      type: 'inside',
      start: 0,
      end: 100
    }, {
      show: false,
      start: 0,
      end: 10,
      handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
      handleSize: '80%',
      handleStyle: {
        color: '#fff',
        shadowBlur: 3,
        shadowColor: 'rgba(0, 0, 0, 0)',
        shadowOffsetX: 2,
        shadowOffsetY: 2
      }
    }],

    series: [
      {
        name: '销售金额',
        type: 'bar',
        showSymbol: true,
        hoverAnimation: false,
        symbolSize: 8,
        data: []
      },
      {
        name: '交易单数',
        type: 'line',
        showSymbol: true,
        hoverAnimation: false,
        symbolSize: 8,
        data: []
      },
    ]
  }
}

export let rightTopPic = {
  id: "rightTopPic",
  charsOption: {
    title: {
      text: '',
      left: 0,
      textStyle: {color: "#333", fontSize: "14", fontWeight: "bold"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      top: 0,
      data: [],
      icon: "circle",
      itemWidth: 12,
      itemHeight: 12,
    },
    color: ["#b24ef2", '#75ccf9', '#017eff', '#ffcf29', '#f2594e', '#40da9b', "#f28f4e", "#ce7676", "#e35788"],
    series: [
      {
        name: '来源',
        type: 'pie',
        top: 40,
        avoidLabelOverlap: false,
        radius: ['50%', '80%'],
        center: ['60%', '50%'],
        label: {
          show: false,
          position: 'center'
        },
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
};

export let rightBottomRightPic = {
  id: "rightBottomRightPic",
  charsOption: {
    title: {},
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      top: 0,
      data: [],
      icon: "circle",
      itemWidth: 12,
      itemHeight: 12
    },
    color: ["#b24ef2", '#75ccf9', '#e35788', "#ffcf29", "#f86055", '#017eff', '#9b8bba', "#a47a7a", "#ce7676", "#e35788"],
    series: [
      {
        name: '来源',
        left: '25%',
        top: 10,
        label: {
          show: false,
          position: 'center'
        },
        type: 'pie',
        radius: '73 %',
        center: ['45%', '58%'],
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
}
export let centerBottomPic = {
  id: "centerBottomPic",
  charsOption: {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    title: {
      text: '会员总数（人）',
      top: -2,
      left: 0,
      textStyle: {color: "#333", fontSize: "14", fontWeight: "bold"},
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: ["男性客户", "女性客户"],
      top: '15%',
      icon: "circle",
      itemWidth: 12,
      itemHeight: 12
    },
    color: ["#017eff", "#f86055"],
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: ['50%', '75%'],
        center: ['60%', '58%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '17',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          {value: 329, name: '男性客户'},
          {value: 310, name: '女性客户'},

        ]
      }
    ]
  }
};










// WEBPACK FOOTER //
// ./src/page/home/options/echartsOptions.js